export default __webpack_public_path__ + "static/media/user.2969c205.png";